export default "__VITE_ASSET__CHpUHg_R__"